import { styled } from '@/stitches.config';

import { Box, Table, TableCell, TableRow } from '../../atoms';

export const TableWrapper = styled(Table, {
  borderCollapse: 'collapse',
  border: 'none',
});

export const StyledTableHeadRow = styled(TableRow, {
  color: '$darkBlue300',
  fontSize: '$4',
  lineHeight: '$6',
  fontWeight: '$bold',
  backgroundColor: '$white',
  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        pointerEvents: 'none',
      },
    },
  },
});

export const StyledNotResultsRowText = styled(TableRow, {
  'tbody &:hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledNotResultsCellText = styled(TableCell, {
  fontWeight: '$medium',
  fontSize: '$5',
  lineHeight: '$6',
  textAlign: 'center',
  margin: '55px auto',
  '&:first-child': {
    paddingLeft: '$4',
  },
  '&:last-child': {
    paddingRight: '$4',
  },
});

export const StyledNotResultsText = styled(Box, {
  alignItems: 'center',
  backgroundColor: '$seafoam700',
  borderRadius: '$8',
  color: '$black',
  display: 'flex',
  fontSize: '$lg',
  fontWeight: '$medium',
  height: '340px',
  justifyContent: 'center',
});

export const PaginationContainerStyled = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  mb: '$12',
  mt: '$8',
  justifyContent: 'center',

  '@sm': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const StyledError = styled(Box, {
  color: '$error',
});
